import { init } from '@telegram-apps/sdk'
import * as telegramSDK from '@telegram-apps/sdk'

window.telegramSDK = telegramSDK

const appTypes = {
  WEB: 'web',
  TELEGRAM: 'telegram',
}

let appType = appTypes.WEB
let telegramContact

try {
  init()
  appType = appTypes.TELEGRAM

  // const launchParams = await telegramSDK.retrieveLaunchParams()
  // const { tgWebAppData: { user } } = await telegramSDK.retrieveLaunchParams();
  // const requestContact = await telegramSDK.requestContact().catch(_ => false)
  // console.log('requestContact ---> ', requestContact)
  // if (requestContact) {
  //   telegramContact = requestContact.contact
  // }

  if(telegramSDK.swipeBehavior.isSupported() && telegramSDK.swipeBehavior.mount()) {
    telegramSDK.swipeBehavior.disableVertical()
  }

  if(telegramSDK.backButton.isSupported() && telegramSDK.backButton.mount()) {
    telegramSDK.backButton.show()
  }
} catch (e) {
  // not Telegram
}


export {appTypes, appType, telegramContact}
